import { CognitoUser } from 'amazon-cognito-identity-js';
import Amplify, { Auth } from 'aws-amplify';

export interface MFAFlowState {
  status: string;
  message: string;
}

class LoginManager {
  private static instance: LoginManager;
  private cognitoUser?: CognitoUser;
  private email = '';
  private pwd = '';

  public static getInstance(): LoginManager {
    if (!LoginManager.instance) {
      LoginManager.instance = new LoginManager();
    }

    return LoginManager.instance;
  }

  public setCustomAuthFlow(): void {
    Amplify.configure({
      Auth: {
        authenticationFlowType: 'CUSTOM_AUTH',
      },
    });
  }

  public async signIn(email: string, password: string) {
    const status = {
      needsVerificationCode: false,
      requireNewPassword: false,
    };
    const user = await Auth.signIn(email, password);
    const { challengeName } = user;
    this.cognitoUser = user;
    this.email = email;
    this.pwd = password;
    switch (challengeName) {
      case 'CUSTOM_CHALLENGE':
        status.needsVerificationCode = true;
        break;
      case 'NEW_PASSWORD_REQUIRED':
        status.requireNewPassword = true;
        break;
      default:
        break;
    }
    return status;
  }

  public async sendVerificationCode(verificationCode: string): Promise<void> {
    await Auth.sendCustomChallengeAnswer(this.cognitoUser, verificationCode);
    // It we get here, the answer was sent successfully,
    // but it might have been wrong (1st or 2nd time)
    // So we should test if the user is authenticated now
    // This will throw an error if the user is not yet authenticated:
    await Auth.currentSession();
  }

  public async reSendVerificationCode(): Promise<MFAFlowState> {
    try {
      await this.signIn(this.email, this.pwd);
      return { status: 'success', message: 'Verification Code sent' };
    } catch (error) {
      return {
        status: 'error',
        message: 'Failed to send verification code.',
      };
    }
  }
}

export default LoginManager;
